import useCollection from 'core/hooks/useCollection'

const usePopulations = ({ supercaseId }) => {
  return useCollection('populations', { supercaseId })
}

export default usePopulations
